export default __webpack_public_path__ + "static/media/icon-SubdirectoryTraining.acbc3299.svg";